import { LitElement, PropertyValues, TemplateResult, html } from 'lit';
import { property, customElement, state, query } from 'lit/decorators.js';
import { styles } from '../view/styles';
import { FontSizes } from '../../../types/common/types';
import { AvailableItemsCardEvents } from '../types';
import { elementClassListAdd, elementClassListRemove } from 'apps/webcomponents/src/utils/htmlElement.utils';

@customElement('gz-available-items-card')
export class GzAvailableItemsCardWebComponent extends LitElement {
  @property({ type: String, attribute: true, reflect: true })
  text = '';

  @property({ type: String, attribute: true, reflect: true })
  outOfItemsText = '';

  @property({ type: Number, attribute: true, reflect: true })
  totalNumber: number;

  @property({ type: Number, attribute: true, reflect: true })
  currentNumber: number;

  @query('#card-wrapper')
  private cardWrapper: HTMLElement;

  @state() isOutOfItems = false;

  static get styles() {
    return styles;
  }

  updated(changedProperties: PropertyValues): void {
    if (changedProperties.has('currentNumber')) {
      if (this.currentNumber < 1) {
        this.currentNumber = 0;
        this.isOutOfItems = true;

        this.handleOutOfItems();
      } else {
        this.isOutOfItems = false;
        this.handleAvailableQuestions();

        if (this.currentNumber > this.totalNumber) {
          this.currentNumber = this.totalNumber;
        }
      }
      this.handleIsOutOfItemsChange();
    }
  }

  render(): TemplateResult {
    return html`
      <div id="card-wrapper">
        <gz-text fontsize="${FontSizes.PARAGRAPH_12}" class="main-text">${this.getText()}</gz-text>
        <div class="d-flex justify-center align-items-center">
          <gz-text fontSize="28" class="mr-1">${this.currentNumber ?? '-'}</gz-text>
          <gz-text fontSize="${FontSizes.PARAGRAPH_12}" class="gray-txt">of ${this.totalNumber ?? '-'}</gz-text>
        </div>
      </div>
    `;
  }

  private getText(): string {
    return !this.isOutOfItems ? this.text : this.outOfItemsText;
  }

  private handleIsOutOfItemsChange(): void {
    if (this.isOutOfItems) {
      elementClassListAdd(this.cardWrapper, 'error-card-wrapper');
    } else {
      elementClassListRemove(this.cardWrapper, 'error-card-wrapper');
    }
  }

  private handleOutOfItems(): void {
    this.dispatchEvent(
      new CustomEvent(AvailableItemsCardEvents.OUT_OF_ITEMS, {
        bubbles: true,
        composed: true,
      })
    );
  }

  private handleAvailableQuestions(): void {
    this.dispatchEvent(
      new CustomEvent(AvailableItemsCardEvents.HAS_AVAILABLE_ITEMS, {
        bubbles: true,
        composed: true,
      })
    );
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'gz-available-items-card': GzAvailableItemsCardWebComponent;
  }
}
